module.exports = __webpack_public_path__ + "static/img/logo1.bfff351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo1.png
// module id = Yn/e
// module chunks = 1